import React from "react";
import { CreateComponentProps } from "./CreateDashboardComponentTab";
import { Button } from "@aidkitorg/component-library";
import { useDashboards } from "../../../Contexts/DashboardsContext";
import { createStagedComponent } from "@aidkitorg/types/lib/admin-panel/dashboard";
import { useLineChartFormState } from "../hooks/useLineChartFormState";
import { LineChartFormFields } from "./LineChartFormFields";
import { useLocalizedStrings } from "../../../Localization";

export const LineChartComponentConfig: React.FC<CreateComponentProps> = ({ setDisplayMode }) => {
  const L = useLocalizedStrings()

  const {
    title, setTitle,
    description, setDescription,
    xAxis, setXAxis,
    yAxis, setYAxis,
    buildLineChartObject,
    isFormStateValid
  } = useLineChartFormState()

  const {
    setStagedComponents,
    getDashboardComponentTranslation
  } = useDashboards()

  const saveLineChartComponent = async () => {
    const newLineChart = buildLineChartObject()

    const translations = await getDashboardComponentTranslation(newLineChart)

    if (translations && translations.success) {
      const stagedComponent = createStagedComponent(newLineChart, translations.data)
      setStagedComponents((prev) => ([...prev, stagedComponent]))
      setDisplayMode('create')
    } else {
      console.error('Failed to translate line chart component:', newLineChart)
      // TODO: Show user-friendly error message
    }
  }

  return (
    <div className="flex flex-col gap-y-2">
      <div className="text-xl font-bold text-gray-900">
        {L.admin_panel.dashboards.add_line_chart}
      </div>

      <LineChartFormFields
        title={title}
        setTitle={setTitle}
        description={description}
        setDescription={setDescription}
        xAxis={xAxis}
        setXAxis={setXAxis}
        yAxis={yAxis}
        setYAxis={setYAxis}
      />

      <div className="flex justify-between gap-x-2 pt-2">
        <Button onClick={() => setDisplayMode('create')} className="!w-1/2" variant="secondary">{L.admin_panel.dashboards.cancel}</Button>
        <Button isDisabled={!isFormStateValid} onClick={saveLineChartComponent} className="!w-1/2">{L.admin_panel.dashboards.save}</Button>
      </div>
    </div>
  )
}